// extracted by mini-css-extract-plugin
export var hidden = "_ph-1";
export var visible = "_ph-0";